<template>
  <v-form
    ref="form"
    @submit.prevent
  >
    <v-row>
      <v-col
        md="9"
        class="d-flex"
      >
        <v-text-field
          v-model="item.name"
          max="200"
          min="0"
          color="blue-grey lighten-2"
          :label="$t('Enter Analysis Name')"
          :rules="[v => !!v || '']"
          :disabled="!editing"
          hide-details
          dense
        />

        <v-checkbox
          v-model="item.checkedForTrack"
          class="ma-0 ml-5"
          dense
          hide-details
          color="blue-grey lighten-2"
          :disabled="!editing"
        />
      </v-col>

      <v-col
        md="3"
      >
        <div>
          <v-btn
            color="primary"
            icon
            @click="onSaveEdit"
          >
            <v-icon
              small
              v-text="editing ? 'mdi-check' : 'mdi-pencil'"
            />
          </v-btn>

          <v-btn
            color="primary"
            icon
            @click="onRemove"
          >
            <v-icon
              small
            >
              mdi-delete
            </v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  // TODO: Add confirmation for delete

    export default {
        name: "CountryWorkloadFormItem",
        props: {
            item: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                editing: false,
            }
        },

        mounted() {
            if(!this.item.name) this.editing = true
        },

        methods: {

            onSaveEdit() {
                if (this.editing) {
                    if(this.$refs.form.validate()) {
                      this.$emit('save');
                      this.editing = !this.editing;
                    }
                } else {
                    this.editing = !this.editing;
                }

            },

            onRemove() {
                this.$emit('remove')
            }
        }
    }
</script>

<style scoped>

</style>
